import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import {
	UntypedFormBuilder,
	UntypedFormGroup,
	Validators,
} from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { Subscription } from 'rxjs';

import { WalletsService } from '../../../../../modules/wallets/wallets.service';
import { SnackBarService } from '../../../../../shared/components/snack-bar/snack-bar.service';

@Component({
	selector: 'app-manage-benefit-date-modal',
	styleUrls: ['./manage-benefit-date-modal.component.scss'],
	templateUrl: './manage-benefit-date-modal.component.html',
})
export class ManageBenefitDateModalComponent implements OnInit, OnDestroy {
	form: UntypedFormGroup;
	isHealth: boolean = false;
	isLoading: boolean = false;

	private readonly onSubmitSubscription$: Subscription = new Subscription();

	constructor(
		public dialogRef: MatDialogRef<ManageBenefitDateModalComponent>,
		private readonly formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA)
		public data: {
			benefitName: string;
			isHealth: boolean;
			walletId: string;
		},
		private readonly snackbarService: SnackBarService,
		private readonly walletsService: WalletsService,
	) {
		this.isHealth = this.data.isHealth;

		this.form = this.formBuilder.group({
			date: [null, [Validators.required]],
			name: [null],
		});
	}

	closeModal() {
		this.dialogRef.close(null);
	}

	ngOnDestroy(): void {
		this.onSubmitSubscription$.unsubscribe();
	}

	ngOnInit(): void {
		const name = this.form.get('name');
		name?.setValue(this.data.benefitName);
		name?.disable();
	}

	onContinue(): void {
		const dateValue = this.form.get('date')?.value;

		if (!dateValue) {
			return;
		}

		const isoDate = new Date(dateValue).toISOString();
		this.dialogRef.close(isoDate);
	}
}
